module.exports = __webpack_public_path__ + "img/AltruvestFullLogo-BlueText.c1b8105a.png";